import React from 'react';
import { connect } from 'react-redux';

import { WithStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';

import { AppState, store, Actions } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import CONFIG from '../../cfg/config';
import { payService, payStatus, bookService, Info, WWWSprzedazInfo, UserData } from '../../api';
import { wciecie, sendErrorLog, phoneSplit } from '../common/helpers';
import TestPlatnosci from '../common/TestPlatnosci';
import { Content } from 'app/formularz/Order';
import DialogInfo from 'app/formularz/DialogInfo';

const outerTheme = createTheme({
  palette: {
    secondary: {
      main: "#3a87ad", dark: "#005a7e"
    },
  },
});


//PM 2021-11-25
//wstrzykniecie tylko uzywanych pol z magazynu danych
type DialogEndProps = {
  dialogEnd: number,
  paymentMethod: number,
  contact: Info,
  info: WWWSprzedazInfo & {
    ip: string;
  },
  success: boolean,
  data: {
    phone: string;
    address: string;
    order: number;
    sum: number;
    id: number;
  }
  paymentId: string,
  //open : boolean
  pay_web: string,
  userData: UserData,
  dostawaData: string,
  firma?: boolean,
  content?: Content[],
}

//PM 2021-10-15
type DialogEndState = {
  open: boolean,
  statusCashBill: string,
  statusPrzelewy24: number,
  interval: NodeJS.Timeout | null,
}

class DialogEnd extends React.Component<DialogEndProps & WithStyles<typeof styles>, DialogEndState> {

  //PM 2021-10-15
  //this.state =
  constructor(props: DialogEndProps & WithStyles<typeof styles>) {
    super(props, {});

    this.state = {
      open: true,
      statusCashBill: this.props.pay_web === '1' || this.props.pay_web === '3'
        ? ((this.props.paymentId && this.props.paymentId !== "")
          ? 'PreStart' : 'PositiveFinish') : '',
      statusPrzelewy24: -1,
      interval: null,
    };
  }

  //PM 2021-10-15
  //uwzglednienie roznych metod platnosci internetowych
  componentDidMount() {
    if (this.props.pay_web === '1')
      if (this.props.paymentId && this.props.paymentId !== "") {
        this.setCustomInterval()
      }
  }

  //PM 2021-11-25
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  componentDidUpdate(prevProps: DialogEndProps) {
    if (this.props.dialogEnd !== prevProps.dialogEnd)
      this.setState({
        open: true
      });


    if (this.props.pay_web === '1')
      if (prevProps.paymentId !== this.props.paymentId && this.props.paymentId && this.props.paymentId !== "") {
        this.setCustomInterval();
        this.setState({ ...this.state, statusCashBill: 'PreStart' });
      }

  };

  //PM 2021-10-18
  //przeniesienie interval do this.state
  setCustomInterval = () => {
    const intervalId = setInterval(() => {
      this.paymentState(this.props.paymentId!);
    }, 5000);

    this.setState({ ...this.state, interval: intervalId });
    setTimeout(() => {
      if (this.state.interval)
        clearInterval(this.state.interval);
    }, 900000);
    // if(this.state.status == "PositiveFinish" || this.state.status == "NegativeAuthorization") {
    //   clearInterval(interval);
    // } 
    // return () => clearInterval(interval); 
  }

  //PM 2021-10-18
  closeDialogEnd = async () => {
    this.setState({ open: false })
  };

  //PM 2021-10-18
  //uwzglednienie roznych metod platnosci internetowych
  //przeniesienie interval do this.state
  //async
  onCloseDialogEnd = async () => {
    await this.closeDialogEnd()

    if (this.props.pay_web === '1') {

      if (this.state.interval)
        clearInterval(this.state.interval);

      if (this.state.statusCashBill !== "PositiveFinish") {
        this.sendFailure();
      }
    }
    else if (this.props.pay_web === '4')
      this.setState({ ...this.state, statusPrzelewy24: -1 });
  };

  //PM 2021-10-18
  //uwzglednienie roznych metod platnosci internetowych
  //przeniesienie interval do this.state
  async paymentState(id: string) {
    //console.log("status")
    try {
      let res: payStatus = await payService.getStatus({ hotelId: CONFIG.hotelID, idPlatnosci: id })
      //console.log(res)            
      this.setState({ statusCashBill: res.status })

      if (res.status === "PositiveFinish") {

        if (this.state.interval)
          clearInterval(this.state.interval);

        this.sendSuccess();
      } else if (res.status !== 'PreStart' &&
        res.status !== 'Start' &&
        res.status !== 'PositiveAuthorization' &&
        res.status !== 'PositiveFinish') {

        if (this.state.interval)
          clearInterval(this.state.interval);

        this.sendFailure();
      }

    } catch (error) {
      console.log(error)
      await sendErrorLog( "0", "-1", '/vscSms/pay/payCashBillStatus')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/vscSms/pay/payCashBillStatus", 2))
    }
  }

  //PM 2021-11-25
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async sendSuccess() {
    let method = this.props.paymentMethod === -1 ? Number(this.props.contact.payWeb) : this.props.paymentMethod
    try {
      await bookService.reservConfirm3(
        {
          hotelId: CONFIG.hotelID,
          aOperatorId: Number(sessionStorage.getItem("operator_id")),
          aDokNr: Number(this.props.data.order) || 0,
          aPayWeb: method
        }, {})
      //console.log(res)  
    } catch (error) {
      console.log(error)
      await sendErrorLog( "0", "-1", '/manager/fakturaKoszykPotwierdz2')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/fakturaKoszykPotwierdz2", 2))
    }
  }

  //PM 2021-11-25
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async sendFailure() {
    let method = this.props.paymentMethod === -1 ? Number(this.props.contact.payWeb) : this.props.paymentMethod
    try {
      await bookService.reservCancel3(
        {
          hotelId: CONFIG.hotelID,
          aOperatorId: Number(sessionStorage.getItem("operator_id")),
          aDokNr: Number(this.props.data.order) || 0,
          aPayWeb: method
        }, {})
      //console.log(res)    
    } catch (error) {
      console.log(error)
      await sendErrorLog( "0", "-1", '/manager/fakturaKoszykAnuluj2')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/fakturaKoszykAnuluj2", 2))
    }
  }

  statusOpis = (status: string): string[] => {
    let opis: string[] = [];

    switch (status) {
      case 'PreStart':
        opis[0] = "płatność została rozpoczęta";
        opis[1] = "klient nie wybrał jeszcze kanału płatności";
        break;
      case 'Start':
        opis[0] = "płatność została rozpoczęta";
        opis[1] = "klient nie dokonał jeszcze wpłaty";
        break;
      case 'PositiveAuthorization':
        opis[0] = "transakcja została wstępnie pozytywnie autoryzowana przez operatora płatności";
        opis[1] = "jej ostateczny status zostanie określony w późniejszym okresie";
        break;
    }

    return opis;
  }

  //PM 2021-10-15
  onPrzelewy24Success = async () => {
    this.setState({ ...this.state, statusPrzelewy24: 1 });

  }

  //PM 2021-10-15
  onPrzelewy24Failure = async () => {
    this.setState({ ...this.state, statusPrzelewy24: 0 });
  }

  //PM 2021-11-25
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render() {
    const { classes } = this.props;
    const czyPlatnosc = this.props.pay_web === "1" || this.props.pay_web === "4"

    //vscTest
    //alert(this.props.pay_web + '\n' + this.state.statusPrzelewy24)

    if (this.props.pay_web === '1' &&
      (this.state.statusCashBill === 'PreStart' ||
        this.state.statusCashBill === 'Start' ||
        this.state.statusCashBill === 'PositiveAuthorization')) {
      const statusOpis = this.statusOpis(this.state.statusCashBill);

      return (
        <Dialog
          disableEscapeKeyDown
          maxWidth="xs"
          open={this.state.open}

        >
          <DialogTitle disableTypography style={{ minWidth: "280px" }}>
            <Typography variant="h5" component="h2" style={{ fontSize: "1.25rem" }} color="primary">
              <b>{"status transakcji"}</b>
            </Typography>
            <hr />
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>


            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              Info
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + statusOpis[0]}
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + statusOpis[1]}
            </Typography>

            {/* <DialogContentText>
              {wciecie + statusOpis[0]}
            </DialogContentText>
            <DialogContentText>
              {wciecie + statusOpis[1]}
            </DialogContentText> */}

          </DialogContent>
          <DialogActions >
            <Button variant="outlined" color="primary" size="small"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
              onClick={this.onCloseDialogEnd}
              disabled={(this.state.statusCashBill === 'PreStart' ||
                this.state.statusCashBill === 'Start' ||
                this.state.statusCashBill === 'PositiveAuthorization')}>
              <b>OK</b>
            </Button>
          </DialogActions>

        </Dialog>
      )
    }
    else if (this.props.pay_web === '4' && this.state.statusPrzelewy24 === -1)
      return (
        <TestPlatnosci
          open={this.state.open}
          pay_web={this.props.pay_web}
          onPrzelewy24Success={this.onPrzelewy24Success}
          onPrzelewy24Failure={this.onPrzelewy24Failure}
          kwota={String(this.props.data.sum)}
          vsc_ident={this.props.data.order}
          ws_sukces={`/manager/fakturaKoszykPotwierdz2?hotelId=${CONFIG.hotelID}&aOperatorId=${Number(sessionStorage.getItem("operator_id"))}&aDokNr=${Number(this.props.data.order) || 0}&aPayWeb=${this.props.paymentMethod === -1 ? Number(this.props.contact.payWeb) : this.props.paymentMethod}`}
          ws_porazka={`/manager/fakturaKoszykAnuluj2?hotelId=${CONFIG.hotelID}&aOperatorId=${Number(sessionStorage.getItem("operator_id"))}&aDokNr=${Number(this.props.data.order) || 0}&aPayWeb=${this.props.paymentMethod === -1 ? Number(this.props.contact.payWeb) : this.props.paymentMethod}`}
        />
      )
    else if (this.props.success === true && (this.state.statusCashBill === "PositiveFinish" || this.state.statusPrzelewy24 === 1 || !czyPlatnosc))
      return (
       <>
       {/* {  this.props.content ? 
       <DialogInfo
            open={this.state.open}
            okCallback={this.onCloseDialogEnd}
            okText={"OK"}
            //cancelCallback={this.closeDialogInfo}
            dialogContent={this.props.content} /> 
            : */}
         <Dialog
          disableEscapeKeyDown
          maxWidth="xs"
          open={this.state.open}

        >
          <DialogTitle disableTypography>
            <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem" }}>
              <b>sukces</b>
            </Typography>
            <hr style={{ marginTop: "10px", minWidth: "320px" }} />
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            <Typography gutterBottom variant="h5" component="h2" color="textSecondary">
              Dziękujemy za złożenie zamówienia
            </Typography>

            {/* <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'numer:'} <b className={classes.primary}>{this.props.data.order}</b>
            </Typography> */}

            {(this.props.userData.dostawaJakiDzien === "" && !this.props.firma) 
            ? (<></>) 
            : (
              <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
                {wciecie + 'data:'} <b className={classes.primary}>{this.props.dostawaData}</b>
              </Typography>
            )
            }
            {
              this.props.userData.dostawaJakiDzien === "" && !this.props.firma ? 
              <>
              <Typography gutterBottom variant="h5" component="h2"  color="textSecondary" style={{marginBottom: "24px"}}>
              {} 
              </Typography> 
              
              <Typography gutterBottom variant="h5" component="h2"  color="textSecondary">
              {'Czas dostawy '} 
              <b className={classes.primary}>
                { this.props.info.www_sprzedaz_czas_oczekiwania_info }
                </b>
            </Typography> 
            </>: 
            
            
            this.props.userData.dostawaGodzMinuta.split(' ').length > 1 ?
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'godz:'} 
              <b className={classes.primary}>
                { this.props.userData.dostawaGodzMinuta.split(' ')[1].replace(':00:00', ':00').replace(':30:00', ':30').replace(':15:00', ':15').replace(':45:00', ':45')}
                </b>
            </Typography> : null}
{/*             
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'kwota:'} <b className={classes.primary}>{this.props.data.sum.toFixed(2) + " zł"}</b>
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary" style={{minHeight: "24px"}}>
              
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'telefon:'} <b className={classes.primary}>{phoneSplit(this.props.data.phone)}</b>
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'adres:'} <b className={classes.primary}>{this.props.data.address.toLowerCase()}</b>
            </Typography> */}
          </DialogContent >
          <DialogActions >
            <Button onClick={this.onCloseDialogEnd} variant="contained" size="small" color="primary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
              <b><Trans>OK</Trans></b>
            </Button>
          </DialogActions>

        </Dialog> 
        {/* } */}
        
        </>

      )
    else
      return (
        
        <Dialog
          disableEscapeKeyDown
          maxWidth="xs"
          open={this.state.open}

        >
          <DialogTitle disableTypography>
            <Typography gutterBottom variant="h5" component="h2" color="error" style={{ fontSize: "1.25rem" }}>
              <b>niepowodzenie</b>
            </Typography>
            <hr />
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Typography gutterBottom variant="h5" component="h2" color="textSecondary">
              Zamówienie nie zostało przyjęte
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'kwota zamówienia:'} <b className={classes.secondary}>{this.props.data.sum.toFixed(2) + " zł"}</b>
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'telefon:'} <b className={classes.secondary}>{phoneSplit(this.props.data.phone)}</b>
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie + 'adres:'} <b className={classes.secondary}>{this.props.data.address.toLowerCase()}</b>
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {" "}
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie} <b className={classes.secondary}>{"spróbuj ponownie"}</b>
            </Typography>
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
              {wciecie}<b className={classes.secondary}>{"lub skontaktuj się z lokalem telefonicznie"}</b>
            </Typography>

          </DialogContent >
          <DialogActions >
            <ThemeProvider theme={outerTheme}>
              <Button onClick={this.onCloseDialogEnd} variant="outlined" size="small" color="secondary"
                style={{ textTransform: "none", fontSize: "0.8rem" }}
              >
                <b><Trans>OK</Trans></b>
              </Button>
            </ThemeProvider>
          </DialogActions>
        </Dialog>

      );
  }
}

const styles = (theme: Theme) => ({
  primary: {
    color: theme.palette.primary.main
  },
  secondary: {
    color: theme.palette.secondary.main
  },
  padding: {
    //whiteSpace: "pre" as "pre",
    paddingLeft: "7px",

    "@media (max-width: 600px)": {
      fontSize: "0.95rem",
    },

  },
  primaryTextField: {
    color: theme.palette.primary.main,
    backgroundColor: "inherit",
    textAlign: 'left' as 'left',
  },
  dialogContent: {
    paddingBottom: '14px'
  }
});

const mapStateToProps = (state: AppState) => ({
  dialogEnd: state.pageState.dialogEnd,
  paymentMethod: state.pageState.paymentMethod,
  contact: state.pageState.contact,
  info: state.pageState.info,
  userData: state.pageState.userData,
  dostawaData: state.pageState.dostawaDataDzien,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogEnd));